import ApplicationAdapter from "./application";

export default class AvailableIpAdapter extends ApplicationAdapter {
  urlForQuery() {
    return `${this.apiBaseUri}/ip/listfree`;
  }
}
